import { RiCheckboxCircleFill } from '@remixicon/react';

import { Icon, ProgressCircle } from '@spotify-internal/encore-web';
import {
  FormFieldsBox,
  FormTextField,
  type FormTextFieldProps,
} from '@spotify/confidence-core-react';

import {
  useAccountDetailsContext,
  useWorkspaceNameFieldsContext,
} from './CreateAccountFormProvider';

export const WorkspaceNameFields = () => {
  const { accountDetails } = useAccountDetailsContext();
  const {
    handleDisplayNameChange,
    handleDisplayNameBlur,
    validDisplayName,
    helperText,
    loginIdAvailable,
    loginIdError,
    loginIdConfirmedAvailable,
    isCheckingAvailability,
  } = useWorkspaceNameFieldsContext();
  const hasError = !validDisplayName || !loginIdAvailable || !!loginIdError;
  let iconTrailing: FormTextFieldProps['iconTrailing'];
  if (isCheckingAvailability) {
    iconTrailing = (
      <ProgressCircle
        aria-label="Checking workspace name"
        size="small"
        semanticColor="textBrightAccent"
      />
    );
  } else if (loginIdConfirmedAvailable) {
    iconTrailing = (
      <Icon
        as={RiCheckboxCircleFill}
        size="small"
        semanticColor="textPositive"
        aria-hidden
      />
    );
  }

  return (
    <FormFieldsBox>
      <FormTextField
        label="Workspace name"
        name="workspace-name"
        indicator="required"
        size="large"
        placeholder="For example My Company"
        value={accountDetails.displayName}
        helperText={hasError ? undefined : helperText}
        error={hasError ? helperText : undefined}
        iconTrailing={iconTrailing}
        required
        onChange={event => handleDisplayNameChange(event.currentTarget.value)}
        onBlur={handleDisplayNameBlur}
      />
    </FormFieldsBox>
  );
};
